export default __webpack_public_path__ + "static/media/Crying.af4f0252.png";